module.exports = __webpack_public_path__ + "static/img/bj2.810c1816.jpg";